import React from 'react';
import { useNavigate } from 'react-router-dom';
import settingsIcon from '../assets/settings.png';
import EmailNotificationToggle from '../components/EmailNotificationToggle';
import SmsPhoneVerification from '../components/SmsPhoneVerification';
import { useAuth } from '../contexts/AuthContext';

const NotificationsSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen sm:min-h-0 w-full max-w-full box-border px-3 py-4 sm:px-4 sm:py-6 md:px-6 md:py-8">
      <div
        className="w-full max-w-full min-w-0 mx-auto md:max-w-2xl rounded-2xl sm:rounded-3xl py-6 px-4 sm:py-8 sm:px-6"
        style={{
          marginTop: '10px',
          backgroundColor: '#262626',
          boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.75)',
        }}
      >
        <div className="flex justify-center items-center mt-4 sm:mt-6 md:mt-8 mb-3 sm:mb-4">
          <img
            className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16"
            src={settingsIcon}
            alt="Settings icon"
          />
        </div>

        <h1 className="font-bold text-center w-full text-lg sm:text-xl my-3 sm:my-4 text-white px-1">
          Notification Settings
        </h1>

        <div className="mt-4 border-t border-gray-700 pt-6 sm:pt-8 w-full max-w-full min-w-0 flex flex-col items-center px-0 sm:px-2">
          <p className="mb-4 sm:mb-6 text-white text-sm sm:text-base text-center px-1 max-w-full">
            {user?.userType === 'startup' ? (
              <>
                Add SMS alerts to hear from interested investors{' '}
                <span className="font-semibold">faster</span>.
              </>
            ) : (
              'In addition to email, we recommend SMS so you can hear from startups more quickly:'
            )}
          </p>

          <div className="w-full max-w-full min-w-0 px-2 sm:px-4 text-left">
            <EmailNotificationToggle />
            <SmsPhoneVerification />
          </div>
        </div>

        <div className="flex justify-end items-center mt-4 sm:mt-6 px-2">
          <button
            onClick={() => navigate('/settings')}
            className="text-gray-400 hover:text-gray-300 transition-colors underline text-sm"
            style={{ textTransform: 'lowercase' }}
          >
            back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationsSettingsPage;
